module.exports = __webpack_public_path__ + "img/wx_detail.7cdc82a.svg";